import { TRESPONSE_GET_LINES_SHIFTS, TRESPONSE_MM_GET_ALL_SHIFTS } from '@monorepo/types';

export type TShiftManagementState = {
  allShiftsRes: TRESPONSE_MM_GET_ALL_SHIFTS | null;
  lineShiftsRes: TRESPONSE_GET_LINES_SHIFTS | null;
};

export const TShiftManagementActionType = {
  FetchAllShifts: 'FETCH_ALL_SHIFTS' as const,
  FetchAllShiftsSuccess: 'FETCH_ALL_SHIFTS_SUCCESS' as const,
  FetchAllShiftsFailure: 'FETCH_ALL_SHIFTS_FAILURE' as const,
  FetchLineShifts: 'FETCH_LINE_SHIFTS' as const,
  FetchLineShiftsSuccess: 'FETCH_LINE_SHIFTS_SUCCESS' as const,
  FetchLineShiftsFailure: 'FETCH_LINE_SHIFTS_FAILURE' as const,
};
